module.exports = __webpack_public_path__ + "static/img/AIRoad.8a2b89ef.png";